define.alias("shared/components/shared/ui/video", "settings/components/shared/ui/video");